export default {
    menu: (state: any): any => state.menu,
    allRoutes: (state: any): any => state.allRoutes,
    asyncRoutes: (state: any): any => state.asyncRoutes,
    tabsList: (state: any): any => state.tabsList,
};
